/**
 * @generated SignedSource<<f712aad2ecf3d035e78e3b26c2b5b2af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ControllerReleaseMaxFilterQuery$variables = Record<PropertyKey, never>;
export type ControllerReleaseMaxFilterQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ControllerReleaseMaxFilter_query">;
};
export type ControllerReleaseMaxFilterQuery = {
  response: ControllerReleaseMaxFilterQuery$data;
  variables: ControllerReleaseMaxFilterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "versioned",
    "value": true
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ControllerReleaseMaxFilterQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ControllerReleaseMaxFilter_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ControllerReleaseMaxFilterQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "ControllerReleaseConnection",
        "kind": "LinkedField",
        "name": "controllerReleases",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ControllerReleaseEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ControllerRelease",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "uuid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "versionString",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "releaseKey",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "controllerReleases(first:10,versioned:true)"
      },
      {
        "alias": null,
        "args": (v0/*: any*/),
        "filters": [
          "versioned",
          "maxVersion"
        ],
        "handle": "connection",
        "key": "ControllerReleaseMaxFilter_controllerReleases",
        "kind": "LinkedHandle",
        "name": "controllerReleases"
      }
    ]
  },
  "params": {
    "cacheID": "b6a43b425ce6d075cb45f406a3b999fe",
    "id": null,
    "metadata": {},
    "name": "ControllerReleaseMaxFilterQuery",
    "operationKind": "query",
    "text": "query ControllerReleaseMaxFilterQuery {\n  ...ControllerReleaseMaxFilter_query\n}\n\nfragment ControllerReleaseMaxFilter_query on Query {\n  controllerReleases(first: 10, versioned: true) {\n    totalCount\n    edges {\n      node {\n        uuid\n        versionString\n        releaseKey\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "163a65df75666f3d148a5764701bcffa";

export default node;
